import { makeStyles } from "@material-ui/core/styles";
import { MYCOLORS } from "../../mypallette";

export const useTestimonialsStyles = makeStyles((theme) => ({
  cardmainLight: {
    minWidth: 275,
    margin: 0,
    padding: 0,
    //background: `linear-gradient(0.25turn, ${MYCOLORS.lpaper}, ${MYCOLORS.ldeck} 50%, ${MYCOLORS.lpaper} )`,
    //background: `radial-gradient(circle at center, ${MYCOLORS.lback} 0%, ${MYCOLORS.lhighlight} 100%)`,
    //background: MYCOLORS.lhighlight,
    background: `linear-gradient(0.5turn, ${MYCOLORS.lcard}, ${MYCOLORS.lhighlight})`,
  },
  cardmainDark: {
    minWidth: 275,
    margin: 0,
    padding: 0,
    background: `radial-gradient(circle at center, ${MYCOLORS.dhighlight} -500%, ${MYCOLORS.dback} 50%)`,
  },
  boxcontainer: {
    //maxWidth: 600,
    margin: 35,
    padding: 0,
  },

  actionArea: {
    borderRadius: 16,
    transition: "0.2s",
    "&:hover": {
      transform: "scale(1.05)",
      //boxShadow: theme.shadows[15],
      // backgroundColor: "#15202B",
      // color: "#15202B",
    },
  },
  innerCardLight: {
    //minWidth: 280,
    maxWidth: 550,
    borderRadius: 16,
    //boxShadow: "none",
    // "&:hover": {
    //   boxShadow: `0 6px 12px 0 ${Color(color).rotate(-12).darken(0.2).fade(0.5)}`,
    //},
    margin: 0,
    padding: 0,
    background: MYCOLORS.lcard,
  },

  innerCardDark: {
    //minWidth: 280,
    maxWidth: 550,
    borderRadius: 16,
    //boxShadow: "none",
    // "&:hover": {
    //   boxShadow: `0 6px 12px 0 ${Color(color).rotate(-12).darken(0.2).fade(0.5)}`,
    //},
    margin: 0,
    padding: 0,
    background: MYCOLORS.dcard,
  },

  small: {
    width: theme.spacing(5),
    height: theme.spacing(5),
  },
  large: {
    width: theme.spacing(10),
    height: theme.spacing(10),
    align: "center",
  },

  // radios: {
  //   //borderRadius: 16,
  //   transition: "0.2s",
  //   "&:hover": {
  //     transform: "scale(1.0)",
  //   },
  // },
}));
